import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const baseUrl = process.env.REACT_APP_API_URL;

const ProviderAndCustomerDetail = () => {
  const location = useLocation(); // Use useLocation to access the URL
  const searchParams = new URLSearchParams(location.search);
  
  // Extract email parameters from URL
  const provider_email = searchParams.get('provider_email');
  const customer_email = searchParams.get('customer_email');

  const [providerDetails, setProviderDetails] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    // Check if both parameters are present
    if (!provider_email || !customer_email) {
      setErrorMessage('Provider email and customer email are required.');
      return;
    }

    // Fetch the provider and customer details
    fetchDetails(provider_email, customer_email);
  }, [provider_email, customer_email]);

  const fetchDetails = async (providerEmail, customerEmail) => {
    try {
      const response = await fetch(`${baseUrl}/provider-customer-details?provider_email=${providerEmail}&customer_email=${customerEmail}`);
      
      if (!response.ok) {
        const error = await response.json();
        console.error('Error fetching details:', error);
        setErrorMessage(error.message || 'Something went wrong');
        return;
      }
  
      const data = await response.json();
      setProviderDetails(data.provider);
      setCustomerDetails(data.customer);
    } catch (error) {
      console.error('Error fetching details:', error);
      setErrorMessage('Failed to fetch details. Please try again.');
    }
  };

  return (
    <div>
      <h1>Provider and Customer Details</h1>

      {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

      {providerDetails && (
        <div>
          <h2>Provider Details</h2>
          <pre>{JSON.stringify(providerDetails, null, 2)}</pre>
        </div>
      )}

      {customerDetails && (
        <div>
          <h2>Customer Details</h2>
          <pre>{JSON.stringify(customerDetails, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export { ProviderAndCustomerDetail };
